import React, { Component } from "react";
import "./style.css";

/**
 * 院校徽标组件
 * 图片地址为空或加载失败时，自动根据学校名称生成默认占位图
 * （校名首字 + 按名称哈希得到的固定底色），避免裂图
 */
const PLACEHOLDER_COLORS = [
  "#5b8ff9",
  "#61ddaa",
  "#65789b",
  "#f6bd16",
  "#7262fd",
  "#78d3f8",
  "#9661bc",
  "#f6903d",
  "#f08bb4",
  "#3bcce1",
];

class SchoolBadge extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imgError: false,
    };
  }

  componentDidUpdate(prevProps) {
    //图片地址变化时重置错误状态
    if (prevProps.src !== this.props.src && this.state.imgError) {
      this.setState({ imgError: false });
    }
  }

  /**
   * 根据学校名称哈希出固定底色，同一所学校颜色保持一致
   */
  getColor(name) {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = (hash * 31 + name.charCodeAt(i)) % 100000;
    }
    return PLACEHOLDER_COLORS[hash % PLACEHOLDER_COLORS.length];
  }

  render() {
    const { src, name, className, style, placeholderFontSize } = this.props;
    const hasSrc =
      src !== null && src !== undefined && String(src).trim() !== "";
    if (!hasSrc || this.state.imgError) {
      const schoolName = name === null || name === undefined ? "" : String(name);
      const text = schoolName.trim().charAt(0) || "学";
      return (
        <div
          className={"school_badge_placeholder " + (className || "")}
          style={{
            backgroundColor: this.getColor(schoolName),
            fontSize: placeholderFontSize || 20,
            ...style,
          }}
        >
          {text}
        </div>
      );
    }
    return (
      <img
        className={className}
        style={style}
        alt=""
        src={src}
        onError={() => this.setState({ imgError: true })}
      ></img>
    );
  }
}

export default SchoolBadge;



// WEBPACK FOOTER //
// ./src/components/School/SchoolBadge/index.js